<template>
  <div class="page-actu">
    
    <main class="main">
      <breadcrumbs></breadcrumbs>
      

      <div class="main-content">
        <div v-if="!mobile" class="left-col">
          <router-link
            class="return"
            :to="{ name: 'news' }"
            title="Retour à la liste des actualités"
          >
            ‹
          </router-link>
        </div>
        <article class="article">
          <subscription-ad-card v-if="!article.public"> </subscription-ad-card>
          <header class="article-header">
            <div class="article-header-top">
              <div class="article_tags" v-if="article.tags">
                <router-link
                  class="tag"
                  v-for="(tag, i) in article.tags"
                  :key="i"
                  :to="{ name: 'news', query: { categorie: tag } }"
                  :class="''"
                >
                  {{ tag }}
                </router-link>
              </div>
              <div class="article-date">
                <div v-if="article.news_date">
                  {{ article.news_date[0] }}/{{ article.news_date[1] }}
                  <span class="annee">{{ article.news_date[2] }}</span>
                </div>
              </div>
            </div>

            <h1 class="article_titre">{{ article.title }}</h1>
          </header>
          <section class="article-contenu">
            <div
              class="article-image"
              v-if="
                article.thumbnail &&
                article.thumbnail.find((thumb) => thumb.size == 990)
              "
              :class="(authenticated && hasActiveSubscription) || article.public ? '' : 'blur'"
            >
              <img
                :src="article.thumbnail.find((thumb) => thumb.size == 990).file"
                alt="article.title"
              />
            </div>
            <div class="article-texte rte" v-html="article.text" :class="(authenticated && hasActiveSubscription) || article.public ? '' : 'blur pointer-events-none'"></div>
          </section>
          <footer class="article-footer">
            <router-link
              class="absolute right-0"
              v-if="article.next_news"
              :to="{ name: 'article', params: { slug: article.next_news } }"
              title="Accéder à l'actualité suivante"
            >
              Actualité suivante
            </router-link>
            <router-link
              class="absolute left-0"
              v-if="article.previous_news"
              :to="{ name: 'article', params: { slug: article.previous_news } }"
              title="Accéder à l'actualité précédente"
            >
              Actualité précédente
            </router-link>
            
            
          </footer>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import News from '@/api/news.js'
import Breadcrumbs from '@/components/Breadcrumbs'
import RightBar from '@/components/RightBar.vue'
import SubscriptionIncentiveCard from '@/components/SubscriptionIncentiveCard.vue'
import SubscriptionAdCard from '@/components/SubscriptionAdCard'

export default {
  name: 'Article',
  components: { Breadcrumbs, RightBar, SubscriptionIncentiveCard, SubscriptionAdCard },

  props: {
    slug: String,
    mobile: Boolean
  },

  data () {
    return {
      article: {}
    }
  },

  created () {
    this.retrieveNews(this.slug)
  },

  beforeRouteUpdate (to, from, next) {
    this.retrieveNews(to.params.slug)
    next()
  },

  methods: {
    retrieveNews (slug) {
      News.retrieve(slug).then((response) => {
        this.article = response
        this.article.news_date = this.article.news_date.split('.')
      })
    },
    canSeeBlur () {
      if (authenticated && hasActiveSubscription) {
        return 'blur'
      }else{
        return ''
      } 
    }
  }, 

  computed: {
    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    },

    hasActiveSubscription () {
      return this.$store.getters['authent/hasActiveSubscription']
    },

    

    

  },

   mounted() {
    window.scrollTo(0,0);
  }
}
</script>
